<template>
    <div class="bar_config chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">段落间距</span>
            <el-input v-model="funnel.gap" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">对齐方式</span>
            <el-select v-model="funnel.funnelAlign" placeholder="请选择位置"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in funnelAlignList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">排列规则</span>
            <el-select v-model="funnel.sort" placeholder="请选择位置"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in sortList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">最小长度</span>
            <el-input v-model="funnel.minSize" @change="getRender" type="number" step="2" min="1" max="100"></el-input>
            <div class="unit">%</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">最大长度</span>
            <el-input v-model="funnel.maxSize" @change="getRender" type="number" step="2" min="1" max="100"></el-input>
            <div class="unit">%</div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'bar_config',
        components: {},
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                funnelAlignList:[{name:'靠左对齐',value:'left'},{name:'居中对齐',value:'center'},{name:'靠右对齐',value:'right'}],
                sortList:[{name:'由下至上',value:'descending'},{name:'由上至下',value:'ascending'}],
                splitAreaAreaStyleColor:[
                    {
                        name:"蓝色系",
                        colorList:['rgba(114, 172, 209, 0.2)','rgba(114, 172, 209, 0.4)', 'rgba(114, 172, 209, 0.6)',
                            'rgba(114, 172, 209, 0.8)', 'rgba(114, 172, 209, 1)']
                    },
                    {
                        name:"红色系",
                        colorList:['rgba(255,35,0,0.2)','rgba(255,95,51,0.4)', 'rgba(255,95,51,0.6)',
                            'rgba(255,95,51,0.8)', 'rgb(255,95,51)']
                    },
                ]
            }
        },
        computed: {
            // funnel

            // funnel() {
            //     return this.$store.state.viewDP.chart.setting.params.funnel;
            // }
            funnel() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params.funnel;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params.funnel;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        watch:{
            "funnel.splitArea.areaStyle.colorName"(){
                this.splitAreaAreaStyleColor.map((val)=>{
                    if(val.name === this.funnel.splitArea.areaStyle.colorName){
                        this.funnel.splitArea.areaStyle.color = val.colorList;
                        this.getRender();
                    }
                })
            }
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .bar_config {

    }
</style>
